import { Controller as BaseController } from '@hotwired/stimulus';
import ChartDataLabels from 'chartjs-plugin-datalabels';
export default class Controller extends BaseController {
  static values = { onGoing: Number, finished: Number, notStarted: Number };

  connect() {
    this.destroyExistingChart();
    var ctx = document.getElementById('exam-status-graph');
    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        datasets: [
          {
            data: [this.finishedValue, this.notStartedValue, this.onGoingValue],
            backgroundColor: ['#E48E4E', '#5C457E', '#E06C9B'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          datalabels: {
            display: false, // Desabilita os labels no gráfico de pizza
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  }

  disconnect() {
    this.destroyExistingChart();
  }

  destroyExistingChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
